const SCROLLABLE_OVERFLOW = new Set(["auto", "scroll"]);

export const canScrollVerticallyWithin = (
	target: EventTarget | null,
	boundary: HTMLElement,
): boolean => {
	for (
		let element = target instanceof Element ? target : null;
		element && element !== boundary;
		element = element.parentElement
	) {
		if (
			element.scrollHeight > element.clientHeight &&
			SCROLLABLE_OVERFLOW.has(window.getComputedStyle(element).overflowY)
		) {
			return true;
		}
	}

	return false;
};
